<ng-container>
    <div class="comp_guidelines_block k-p-2 k-container">
        <div class="k-container-fluid">
            <div class="title_heading">
                <h1>Integration Log</h1>
            </div>

            <div class="tab">
                <h4>View:</h4>
                <a [ngClass]="{'active':tabSelected == 'All'}" href="javascript:void(0)"
                    (click)="changeTab('All')">All</a>
                <a [ngClass]="{'active':tabSelected == 'Error'}" href="javascript:void(0)"
                    (click)="changeTab('Error')">Errors</a>
                <a [ngClass]="{'active':tabSelected == 'Success!'}" href="javascript:void(0)"
                    (click)="changeTab('Success!');">Success</a>
                <button kendoButton fillMode="outline" class="tab-action-item"
                    (click)="openCloseRequestPopup('new', null)">
                    <fa-icon [icon]="iconPacks.FACIRCLEPLUS"></fa-icon> New request
                </button>
            </div>

            <div>
                <app-custom-grid-filter class="integration-log"
                [oldAdvanceFilterResponse]="oldAdvanceFilterResponse"
                [filterId]="filterId"
                    [infoNote]="infoNote" [advancedFilterAllow]="false" [placeHolder]="'Search by Request or Message'"
                    (filterCustomData)=" filterCustomData($event)"></app-custom-grid-filter>
            </div>
            <!-- Grid -->
            <div class="div-gridm">
                <button kendoButton class="btn-cancel btn-reprocess" (click)="reProcess()">
                    Reprocess
                </button>
                <kendo-grid class="mt-10" [data]="integrationLogList" [resizable]="true" [sortable]="true"
                    (sortChange)="sortChange($event)" [sort]="sort">
                    <ng-template kendoGridNoRecordsTemplate>
                        <div class="norecordsmwobuild">No request jsons to show...</div>
                    </ng-template>
                    <kendo-grid-column title="INTERNAL ID" field="id" [sortable]="true" [width]="150">
                        <ng-template kendoGridCellTemplate let-dataItem> {{dataItem.id}} </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="REQUEST" field="requestId">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <ng-container>
                                <a *ngIf="dataItem.materialMasterName" class="a-request"
                                    [routerLink]="['/Material-Details',dataItem.materialMasterName]">
                                    {{dataItem.requestId}}</a>
                                <span *ngIf="!dataItem.materialMasterName">{{dataItem.requestId}}</span>
                            </ng-container>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="STATUS" field="processedStatus"  [width]="120">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span>
                                @if(dataItem.processedStatus == 2){
                                        {{statusList[dataItem.processedStatus]}}

                                        <ng-container *ngIf="dataItem.processedStatus == 2">
                                            <fa-icon class="iconInfoError" kendoTooltip title="{{dataItem.errorMessage}}"
                                                [icon]="iconPacks.FAINFOCIRCLE"></fa-icon>
                                        </ng-container>


                                } @else {
                                    {{statusList[dataItem.processedStatus]}}
                                }
                            </span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="RECEIVED ON" field="savedOn">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span kendoTooltip title="{{dataItem.savedOn | dateFormatter:'dd-MMM-yyyy HH:mm:ss'}}">
                                {{ dataItem.savedOn | relativeDate }}
                            </span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="PROCESSED ON" field="processedOn">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span kendoTooltip title="{{dataItem.processedOn| dateFormatter: 'dd-MMM-yyyy HH:mm:ss'}}">
                                {{dataItem.processedOn | relativeDate}}</span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column title="MATERIAL NAME" field="materialMasterName"
                        [sortable]="false"></kendo-grid-column>
                    <kendo-grid-column title="" field="materialMasterName" [sortable]="false" [width]="100">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <fa-icon (click)="openCloseRequestPopup('old', dataItem)" class="iconInfo" kendoTooltip
                                title="View content" [icon]="iconPacks.FAEYE"></fa-icon>
                            <fa-icon (click)="runProcess(dataItem)" *ngIf="dataItem.processedStatus!=3" class="iconInfo"
                                kendoTooltip title="Run process" [icon]="iconPacks.FAGEARS"></fa-icon>

                        </ng-template>
                    </kendo-grid-column>
                </kendo-grid>
                <br/>
                <app-custom-pager [pageSize]="pageSize" [skip]="skip" [total]="integrationLogList.total"
                    (pageChange)="pageChange($event)"></app-custom-pager>

            </div>

        </div>
    </div>
</ng-container>
<app-content-popup class="process-popoup" *ngIf="requestPopup" [width]="400" (closeContentPopUp)="openCloseRequestPopup()"
    [dialogTitle]="tital">

    <kendo-textarea [(ngModel)]="cJsonText" placeholder="..." [rows]="20" resizable="vertical"></kendo-textarea>

    <button type="button" (click)="clickProcess();" kendoButton class="btn-save process-btn">Process</button>
</app-content-popup>